module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Page not found","title":"Link is invalid or expired","description":"The interview link you followed doesn\u0027t exist or has already expired. Please check the link or contact the person who invited you.","action":"Go to Huntica"}}')
  delete Component.options._Ctor
}
